/** Which copy of the CRM this is, told from its address: staging.… is Staging; localhost, 127.0.0.1, the compose
 * "web" host and the Vite dev server are Dev; anything else is live and shows no label (owner request 2026-10-15). */
import { StatusBadge } from '@/components/StatusBadge'
import { t } from '@/lib/text'

export type AppEnvironment = 'staging' | 'dev' | null

const DEV_HOSTS = new Set(['localhost', '127.0.0.1', 'web'])

export function appEnvironment(hostname: string = window.location.hostname, devServer: boolean = import.meta.env.DEV): AppEnvironment {
  if (hostname.startsWith('staging.')) return 'staging'
  if (devServer || DEV_HOSTS.has(hostname)) return 'dev'
  return null
}

export function titleWithEnvironment(title: string, environment: AppEnvironment = appEnvironment()): string {
  return environment ? `${t(`core.shell.environment.${environment}`)} · ${title}` : title
}

/** "PC Forms CRM" plus an amber Staging (or Dev) badge, so nobody mistakes a test copy for the live one. */
export function AppName({ environment = appEnvironment(), className }: { environment?: AppEnvironment; className?: string }) {
  return (
    <span className={className}>
      <span className="truncate">{t('core.shell.app_name')}</span>
      {environment && (
        <StatusBadge tone="warning" className="ms-2 align-middle">
          {t(`core.shell.environment.${environment}`)}
        </StatusBadge>
      )}
    </span>
  )
}
